import React from 'react';
import { InputField } from 'components/common';
import { Row, InputWrapper, InputLabel } from 'container/Reservation/components/ReservationForm/styles';
import { Select } from "../../../components/common";
import { useTranslation } from 'react-i18next'; // Import useTranslation hook
import { useDispatch, useSelector } from "react-redux";
import { selectMarina, selectMarinas } from 'store/slices/app/selectors';
import { reservationActions } from 'store/slices/reservation/reservationSlice';
import { selectVessel } from 'store/slices/reservation/selectors';
import { NatureOfTravel, HullType, VesselType } from 'settings/enums';
import { ErrorMessage, Section, ErrorMessageDoc } from 'container/Reservation/components/ReservationInputs/ReservationInputs.style';
import PropTypes from "prop-types";
import countries from 'utils/countries';
import Document from 'components/Document/DocumentWithFormik';
import HomeMarinaSelect from './homeMarinaSelect';

const BeforeApprovalForm = (props) => {
    const {formik, requirements_before_approval, isLoggedIn, isNewVessel, submitted} = props;

    const { t } = useTranslation();
    const dispatch = useDispatch();

    const marina = useSelector(selectMarina);
    const selectedVessel = useSelector(selectVessel);

    const renderSelect = (
        label,
        hint,
        key,
        onChange,
        options,
        disabled
    ) => (
        <InputWrapper>
            <InputLabel>{t(label)}</InputLabel>
            <Select
                value={formik.values[key]}
                options={options}
                onChange={onChange}
                error={submitted && !!formik.errors[key]}
                hint={t(hint)}
                disabled={disabled}
            />
            {submitted && formik.errors[key] && <ErrorMessage>{formik.errors[key]}</ErrorMessage>}
        </InputWrapper>
    );

    const renderInput = (
        label,
        key,
        onChange,
        type,
        disabled
    ) => (
        <InputWrapper>
            <InputLabel>{t(label)}</InputLabel>
            <InputField  error={submitted && !!formik.errors[key]} value={formik.values[key] || ''}
                        onChange={onChange} type={type || 'text'} disabled={disabled}/>
            {submitted && formik.errors[key] && <ErrorMessage>{formik.errors[key]}</ErrorMessage>}
        </InputWrapper>);

    return (
        <>

            {requirements_before_approval?.vesselName && <Row>
                {renderInput('BOAT_NAME', 'vesselName', (name)=>{formik.setFieldValue('vesselName', name);
            dispatch(reservationActions.setVesselName(name))})}
            </Row>}

            {requirements_before_approval?.emailAddress && <Row>
                {renderInput('ENTER_YOUR_EMAIL', 'emailAddress', (mail)=>{formik.setFieldValue('emailAddress', mail);
                dispatch(reservationActions.setMail(mail.toLowerCase()))})}
            </Row>}
            {requirements_before_approval?.homeMarina && (
                <Row>
                    <InputWrapper>
                        <HomeMarinaSelect
                            formik={formik}
                            selectedVessel={selectedVessel}
                            submitted={submitted}
                        />
                        {submitted && formik.errors.homeMarinaId && <ErrorMessage>{formik.errors.homeMarinaId}</ErrorMessage>}
                    </InputWrapper>
                </Row>
            )}
            {requirements_before_approval?.natureOfTravel && (
                <Row>
                    {renderSelect(
                        'NATURE_OF_TRAVEL',
                        'SELECT_NATURE_OF_TRAVEL',
                        'natureOfTravel',
                        (natureOfTravel) => {
                            formik.setFieldValue('natureOfTravel', natureOfTravel);
                            dispatch(reservationActions.setNatureOfTravel(natureOfTravel));
                        },
                        Object.keys(NatureOfTravel).map(opt => ({label: t(opt), value: opt}))
                    )}
                </Row>
            )}
            {requirements_before_approval?.vesselType && <Row>
            {renderSelect('BOAT_TYPE',
            'SELECT_BOAT_TYPE',
            'vesselType',
                (type)=>{formik.setFieldValue('vesselType', type);
                    dispatch(reservationActions.setVesselType(type));},
                     Object.keys(VesselType).map(opt => ({ label: t(opt), value: opt })),
                      (!isNewVessel && selectedVessel?.type))
                      }
            </Row>}
            {requirements_before_approval?.hullType && <Row>
                {renderSelect('HULL_TYPE',
                    'SELECT_HULL_TYPE',
                    'hullType',
                    (type)=>{formik.setFieldValue('hullType', type);
                             dispatch(reservationActions.setHullType(type));
                    },
                    Object.keys(HullType).map(opt => ({ label: t(opt), value: opt })),
                    (!isNewVessel && selectedVessel?.hull_type))
                }
            </Row>}
            <Row>
                {!isLoggedIn && requirements_before_approval?.firstName && renderInput('FIRST_NAME', 'firstName', (name)=>{formik.setFieldValue('firstName', name);
            dispatch(reservationActions.setFirstName(name));})}
                {!isLoggedIn && requirements_before_approval?.lastName && renderInput('LAST_NAME', 'lastName', (name)=>{formik.setFieldValue('lastName', name);
            dispatch(reservationActions.setLastName(name));})}
            </Row>
            {requirements_before_approval?.phone && <Row>
                {renderInput('PHONE_NUMBER_INCL',
                'phone',
                (num)=>{formik.setFieldValue('phone', num);
                        dispatch(reservationActions.setPhone(num));},
                'tel',
                )}
            </Row>}
            {requirements_before_approval.liveAboard &&
                <Section>
                    <div style={{display: 'flex'}}>
                        <input  type="checkbox" checked={formik.values.liveAboard}
                               onChange={()=>{formik.setFieldValue('liveAboard', !formik.values.liveAboard);}}/>
                        <span style={{marginLeft: '5px'}}>Liveaboard (live onboard)</span>
                    </div>
                </Section>
            }
            {requirements_before_approval.waterElectricity &&
                <Section>
                    <div style={{display: 'flex'}}>
                        <input  type="checkbox" checked={formik.values.waterElectricity}
                               onChange={()=>{formik.setFieldValue('waterElectricity', !formik.values.waterElectricity);}}/>
                        <span style={{marginLeft: '5px'}}>{t('NEED_WATER_AND_ELECTRICITY')}</span>
                    </div>
                </Section>
            }
            {requirements_before_approval?.address && <Row>
            {renderInput('ADDRESS', 'address',  (address)=>{formik.setFieldValue('address', address);
                                                dispatch(reservationActions.setAddress(address));})}
        </Row>}
        {requirements_before_approval?.postCode && <Row>
            {renderInput('POST_CODE', 'postCode', (postCode)=>{formik.setFieldValue('postCode', postCode);
        dispatch(reservationActions.setPostCode(postCode));})}
        </Row>}
        {requirements_before_approval?.country && <Row>
            {renderSelect('COUNTRY', 'SELECT_COUNTRY', 'country', (country)=>{formik.setFieldValue('country', country);
        dispatch(reservationActions.setCountry(country));}, countries)}
        </Row>}
        {requirements_before_approval?.skipper_id && <Row>
            <Document
                  label={t('SKIPPER_ID_LICENSE')}
                  type='SKIPPER_ID_LICENSE'
                  name='skipper_id'
                  file={formik.values.skipper_id}
                  onChange={value => {
                    //   refreshData({ parameters: ['attachments'] });
                      dispatch(reservationActions.setskiperIdFile(value))
                  }}
                  onRemove={()=>{
                    // refreshData({ parameters: ['attachments'] });
                  }}
                  marinaName={marina.name}
                  vessel_id={selectedVessel?.id}
                  formik={formik}
                />
                {submitted && formik.errors['skipper_id'] && <ErrorMessageDoc >{formik.errors['skipper_id']}</ErrorMessageDoc>}

        </Row>}
        {requirements_before_approval?.vessel_license && <Row>
            <Document
                  label={t('VESSEL_LICENSE')}
                  type='VESSEL_LICENSE'
                  name='vessel_license'
                  file={formik.values.vessel_license}
                  onChange={value => {

                    //   refreshData({ parameters: ['vessels'], vessel_id: selectedVessel?.id });
                      dispatch(reservationActions.setvesselLicenseFile(value))

                  }}
                  onRemove={()=>{
                    // refreshData({ parameters: ['vessels'] });
                  }}
                  marinaName={marina.name}
                  vessel_id={selectedVessel?.id}
                  formik={formik}
                />
                {submitted && formik.errors['vessel_license'] && <ErrorMessageDoc >{formik.errors['vessel_license']}</ErrorMessageDoc>}

        </Row>}

        {requirements_before_approval?.vessel_photo && <Row style={{alignItems: 'center'}}>

            <Document
                  label={t('VESSEL_PHOTO')}
                  type='VESSEL_PHOTO'
                  name='vessel_photo'
                  file={formik.values.vessel_photo}
                  onChange={value => {
                    // refreshData({ parameters: ['vessels'], vessel_id: selectedVessel?.id  });
                    dispatch(reservationActions.setvesselPhotoFile(value))
                  }}
                  onRemove={()=>{
                    // refreshData({ parameters: ['vessels'] });
                  }}
                  marinaName={marina.name}
                  vessel_id={selectedVessel?.id}
                  formik={formik}

                />
            {submitted && formik.errors['vessel_photo'] && <ErrorMessageDoc >{formik.errors['vessel_photo']}</ErrorMessageDoc>}

        </Row>}
        {requirements_before_approval?.vessel_insurance && <Row>
            <Document
                  label={t('VESSEL_INSURANCE')}
                  type='VESSEL_INSURANCE'
                  name='vessel_insurance'
                  file={formik.values.vessel_insurance}
                  onChange={value => {

                    //   refreshData({ parameters: ['vessels'] , vessel_id: selectedVessel?.id });
                      dispatch(reservationActions.setvesselInsuranceFile(value))

                  }}
                  onRemove={()=>{
                    // refreshData({ parameters: ['vessels'] });
                  }}
                  marinaName={marina.name}
                  vessel_id={selectedVessel?.id}
                  formik={formik}


                />
                {submitted && formik.errors['vessel_insurance'] && <ErrorMessageDoc >{formik.errors['vessel_insurance']}</ErrorMessageDoc>}

        </Row>}

        </>
    );
}

BeforeApprovalForm.propTypes = {
    submitted: PropTypes.bool,
    isNewVessel: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    requirements_before_approval: PropTypes.object,
    formik: PropTypes.object
}

export default BeforeApprovalForm;
